import * as React from 'react';
import { Link } from "react-router-dom";
import { MedicineForListModel } from "../../models";
import Translate from '../../common/functions/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const medicinesList = (props) => {
	const listItems = props.medicines.map((m: MedicineForListModel) =>
		<li key={m.medicineId}>
			<div className="item-info">
				<div className="item-name">
					{m.brandName ? m.brandName : ''}
				</div>
				<div className="item-desc">
					{m.additionalTitle ? m.additionalTitle : ''}
				</div>
			</div>
			<div className="item-actions">
				{props.withRemoveAction ?
					<span>
						<a href='' onClick={(e) => props.onRemoveClick(e, m.medicineId)} title={Translate('Remove')} >
							<FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f50057', fontSize: '1.3em', margin: '0 2px' }} />
						</a>
					</span> : null}
			</div>
		</li>
	);

	return (
		<ul className="list-items">
			{listItems}
		</ul>
	)
}

export default medicinesList;
